import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";
import { Provider } from "react-redux";
import store from "./state/store";
import App from "./app";
import { Router } from "react-router-dom";
import { toasterConfig } from "./toast";
import ModalManager from "./modals/manager";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
       <Toaster {...toasterConfig} />
           <Provider store={store}>
             <App />
             <ModalManager />
           </Provider>
  </React.StrictMode>
);
